
export const setCountryFilterSearch = (country) => (
    {
      type:'SET_COUNTRY_FILTER_SEARCH',
      country,
    }
  );
  
  
  export const setStateFilterSearch = (localState) => (
    {
      type:'SET_STATE_FILTER_SEARCH',
      localState,
    }
  );

  export const setAreaFilterSearch = (localArea) => (
    {
      type:'SET_AREA_FILTER_SEARCH',
      localArea,
    }
  );

  export const setSelectedListing = (selectedListing) => (
    {
      type:'SET_SELECTED_LISTING',
      selectedListing,
    }
  );

  export const setSearchModalDisplay = (searchModalDisplay) => (
    {
      type:'SET_SEARCH_MODAL_DISPLAY',
      searchModalDisplay,
    }
  );

  export const setPropertyType = (propertyType) => (
    {
      type:'SET_PROPERTY_TYPE_FILTER_SEARCH',
      propertyType,
    }
  );

  export const setPurchaseOption = (purchaseOption) => (
    {
      type:'SET_PURCHASE_OPTION_FILTER_SEARCH',
      purchaseOption,
    }
  );


  export const setCategoryType = (categoryType) => (
    {
      type:'SET_CATEGORY_FILTER_SEARCH',
      categoryType,
    }
  );

  export const setListingType = (listingType) => (
    {
      type:'SET_LISTING_SEARCH',
      listingType,
    }
  );

  export const setPropertyPrice = (propertyPrice) => (
    {
      type:'SET_PROPERTY_PRICE_FILTER_SEARCH',
      propertyPrice,
    }
  );

  export const setListingID = (listingID) => (
    {
      type:'SET_LISTING_ID',
      listingID,
    }
  );